module.exports = __webpack_public_path__ + "static/media/dinesh_publications.da64dd4e.gif";